import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import SectionMessage from '@atlaskit/section-message';
import { GET_APP_NAME } from '../web-client';
export var UIKit1DeprecationMessage = function UIKit1DeprecationMessage(props) {
  var client = props.client,
    extension = props.extension;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    appName = _useState2[0],
    setAppName = _useState2[1];
  useEffect(function () {
    if (client) {
      var response = client.query({
        query: GET_APP_NAME,
        variables: {
          id: extension.id
        }
      });
      response.then(function (data) {
        var _data$data;
        var appName = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.app.name;
        setAppName(appName);
      });
    }
  }, [client, extension.id]);
  var title = appName ? appName : extension.properties.title;
  var message = "".concat(title, " version is outdated due to a deprecated platform component.\nThe app developer needs to update it to a compatible version.\nPlease ask your admin to check for updates or contact the app developer.");
  return /*#__PURE__*/React.createElement(SectionMessage, {
    title: "App update required",
    appearance: "error"
  }, message);
};